/* React and components imports  */
import React, { useState, useEffect } from 'react'
/* API */
import { resetPassword } from '../../Api'
/* Router */
import { useLocation, useHistory } from 'react-router-dom'
/* React Hook Form */
import { useForm } from 'react-hook-form'
/* React Query */
import { useMutation } from 'react-query'
import BaseAlert from '../Snackbar/NewImplementations/BaseAlert/BaseAlert'
import resetStyles from './styles.module.css'
import ColorAlert from '../Snackbar/NewImplementations/ColorAlert/ColorAlert'
import useAlerts from '../Snackbar/NewImplementations/HooksAlerts/useAlerts'

export default function NewPassword () {
  // Local state for both inputs
  const [password, setPassword] = useState({
    newPassword: '',
    confirmPassword: ''
  })

  // react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    watch
  } = useForm({ mode: 'onSubmit' })

  // Central alert for API responses
  const [alert, setAlert] = useState({
    open: false,
    title: '',
    body: '',
    color: '#48B966',
    actions: []
  })

  // Client-side validation toasts
  const { alerts, closeAlert, showValidationErrors } = useAlerts()

  // Routing helpers
  const history = useHistory()
  const path = '/home'
  const query = new URLSearchParams(useLocation().search)
  const token = query.get('token')

  const backToLogin = () => setTimeout(() => history.push(path), 3000)
  const linkBackToLogin = () => history.push(path)

  // Keep local state in sync with inputs
  const handleInputChange = ({ target }) =>
    setPassword(prev => ({ ...prev, [target.name]: target.value }))

  // Mutation
  const [mutate, { isLoading }] = useMutation(
    ({ token, password }) => resetPassword(token, { password }),
    { onSuccess: handleSuccess, onError: handleError }
  )

  function handleSuccess (data) {
    if (data.status >= 400) {
      setAlert({
        open: true,
        title: 'Error',
        body: 'Something went wrong, try again.',
        color: '#EF3688'
      })
      reset()
      backToLogin()
    } else {
      setAlert({
        open: true,
        title: 'Password changed',
        body: 'Password has been changed, you will be redirected to the login...',
        color: '#48B966'
      })
      reset()
      backToLogin()
    }
  }

  function handleError (error) {
    // Optional: display or log the error
  }

  // Submit handler – only send the new password string
  const handleReset = () => {
    mutate({ token, password: password.newPassword })
  }

  useEffect(() => {
    document.title = 'Datafiniti Portal | Reset Password'
  }, [])

  return (
    <section className={resetStyles.mainContainer}>
      <div className={resetStyles.background} />

      <div className={resetStyles.contentContainer}>
        <div>
          <img
            className={resetStyles.logo}
            alt='Datafiniti logo'
            src={require('../HomeDR12/images/datafiniti-logo-white.svg')}
          />
          <span className={resetStyles.resetPasswordSpan}>Reset password</span>

          <form onSubmit={handleSubmit(handleReset, showValidationErrors)}>
            <div className={resetStyles.inputContainer}>
              <input
                name='newPassword'
                type='password'
                placeholder='New password'
                className={resetStyles.inputField}
                {...register('newPassword', {
                  required: 'New password is required',
                  onChange: handleInputChange
                })}
              />
              <input
                name='confirmPassword'
                type='password'
                placeholder='Confirm password'
                className={resetStyles.inputField}
                {...register('confirmPassword', {
                  required: 'Confirm password is required',
                  validate: value =>
                    value === watch('newPassword') || 'Passwords do not match',
                  onChange: handleInputChange
                })}
              />
            </div>

            <button
              className={resetStyles.changeButtonPassword}
              type='submit'
              disabled={isLoading}
            >
              Confirm
            </button>
          </form>

          <span className={resetStyles.backToLogin} onClick={linkBackToLogin}>
            Back to login
          </span>

          {/* Client-side validation toasts */}
          {alerts.map((a, i) => (
            <ColorAlert
              key={a.id}
              open={a.open}
              type={a.type}
              label={a.message}
              onClose={() => closeAlert(a.id)}
              style={{ bottom: 20 + i * 80 }}
            />
          ))}

          {/* API success / error alert */}
          <BaseAlert
            open={alert.open}
            title={alert.title}
            body={alert.body}
            color={alert.color}
            actions={alert.actions}
            onClose={() => setAlert(a => ({ ...a, open: false }))}
            style={{ width: '320px' }}
          />
        </div>
      </div>
    </section>
  )
}
